import ko from "./ko";
import ja from "./ja";
import API from "@api/index";
import { LOCALES } from "constants/locales";
import dayjs, { changeLocale } from "plugins/dayjs";

//* DECLARE TYPES
export const LANGUAGES = {
  ko,
  ja,
} as const;
export type TLanguage = keyof typeof LANGUAGES;


//* LOCALE
export const getLocale = () => {
  return process.env.LOCALE!;
};

export const APP_LOCALE = getLocale();

export const IS_JAPAN = APP_LOCALE === LOCALES.JA;


//* LANGUAGE - FIRST SETTER by env
const DEFAULT_LANGUAGE = (process.env.LOCALE ?? LOCALES.KO) as TLanguage;
let _languageCurrent: TLanguage = DEFAULT_LANGUAGE;

export const setLanguage = (locale: TLanguage) => {
  _languageCurrent = locale;
  
  changeLocale(dayjs, _languageCurrent);

  API.axios.interceptors.request.use(function (config: any) {
    config.headers.locale = _languageCurrent;
    config.headers.Locale = _languageCurrent;
    return config;
  });
};

export const getLanguage = () => {
  const languageState = (_languageCurrent ?? DEFAULT_LANGUAGE) as TLanguage;
  return languageState;
}


//* LANGUAGE - SECOND SETTER by App.tsx
export const initLanguage = (locale:any) => {
  // const locale = detectBrowserLanguage();
  const _locale = (locale ?? _languageCurrent ?? DEFAULT_LANGUAGE) as TLanguage;
  const language = _locale?.split("-")[0];

  // @ts-ignore
  setLanguage(language in LANGUAGES ? language : DEFAULT_LANGUAGE);
};

export const useLanguage = () => {
  return LANGUAGES[getLanguage()];
};
